import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';


export interface ActivateUserModel {
	title:string;
    button:string;
    message:string;
}

@Component({  
    selector: 'activate-user',
    templateUrl: './activate-user.html',
    styleUrls: ['./activate-user.scss']
})

export class ActivateUserComponent extends DialogComponent<ActivateUserModel, any> implements ActivateUserModel, OnInit {
  	title:string;
    button:string;
    message:string;

    private passwordForm: FormGroup;
    private password:AbstractControl;

  	constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
    ) {
    	super(dialogService);
  	}

    ngOnInit() {
        this.passwordForm = this.formBuilder.group({
            password: ['', Validators.compose([Validators.required, Validators.minLength(5)])]
        });

        this.password = this.passwordForm.controls['password'];
    }

    confirm() {
        // we set dialog result as true on click on confirm button, 
        // then we can get dialog result from caller code
        this.result = this.passwordForm.value.password;
        this.close();
    }
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/activate-user/activate-user.component.ts